document.addEventListener('DOMContentLoaded', () => {
    // Scrollbar Indicator Animation
    function updateScrollbarIndicator() {
        const indicator = document.querySelector('.scrollbar-indicator');
        if (!indicator) return;

        const doc = document.documentElement;
        const sh = doc.scrollHeight;
        const ch = doc.clientHeight;
        // Use window.scrollY for better cross-browser support
        const st = window.scrollY || doc.scrollTop;

        // Estimate scrollbar thumb height
        // thumbHeight / clientHeight = clientHeight / scrollHeight
        let thumbHeight = (ch / sh) * ch;
        // Enforce a minimum intuitive size (e.g., 30px)
        if (thumbHeight < 30) thumbHeight = 30;

        // The thumb moves within the available track space
        const availableTrack = ch - thumbHeight;

        // Scroll percentage (avoid division by zero if no scroll)
        const scrollableDistance = sh - ch;
        const scrollPercent = scrollableDistance > 0 ? st / scrollableDistance : 0;

        // Calculate thumb's top position
        const thumbTop = scrollPercent * availableTrack;

        // Center of thumb
        const thumbCenter = thumbTop + (thumbHeight / 2);

        // Apply position
        indicator.style.top = `${thumbCenter}px`;

        // Configuration for fade positions
        const isMobile = window.innerWidth < 768;
        const settings = window.scrollbarSettings || {};

        // Mobile Thresholds
        const mobileFadeIn = settings.mobileFadeIn || 500;
        const mobileFadeOut = settings.mobileFadeOut || 1050;

        // PC Thresholds
        const pcFadeIn = settings.pcFadeIn || 500;
        const pcFadeOut = settings.pcFadeOut || 500;

        const limitTop = isMobile ? mobileFadeIn : pcFadeIn;
        const limitBottom = isMobile ? mobileFadeOut : pcFadeOut;

        // Fade in/out based on scroll position to avoid header overlap
        // AND fade out near the bottom to avoid footer overlap
        const distToBottom = sh - (st + ch);

        if (st > limitTop && distToBottom > limitBottom) {
            indicator.style.opacity = '1';
        } else {
            indicator.style.opacity = '0';
        }
    }

    if (document.querySelector('.scrollbar-indicator')) {
        window.addEventListener('scroll', updateScrollbarIndicator, { passive: true });
        window.addEventListener('resize', updateScrollbarIndicator);
        // Run once immediately
        updateScrollbarIndicator();
    }
});
